import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import PrivateRoute from './layouts/PrivateRoute';
import MultiAudioForm from './content/dashboards/Audio/MultiAudioForm';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages
const Login = Loader(lazy(()=> import('src/content/auth/login')))
const Overview = Loader(lazy(() => import('src/content/overview')));

// Dashboards

const Category = Loader(lazy(() => import('src/content/dashboards/Category')));
const SubCategory = Loader(
  lazy(() => import('src/content/dashboards/SubCategory'))
);
const Audio = Loader(
  lazy(() => import('src/content/dashboards/Audio'))
);
const Artists = Loader(
  lazy(() => import('src/content/dashboards/Artists'))
);
const Reviews = Loader(
  lazy(() => import('src/content/dashboards/Reviews'))
);
const AddAudio = Loader(
  lazy(() => import('src/content/dashboards/Audio/MultiAudioForm'))
);
const PrivacyPolicy = Loader(lazy(()=> import ('src/content/dashboards/PrivacyPolicy')));
const TermAndCondition = Loader(lazy(()=> import ('src/content/dashboards/Term&Condition')));
const AboutUs = Loader(lazy(()=> import ('src/content/dashboards/AboutUs')));
const SendNotification = Loader(lazy(()=> import ('src/content/dashboards/SendNotification')));


// Applications

const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);

// Components

const Buttons = Loader(
  lazy(() => import('src/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('src/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('src/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(
  lazy(() => import('src/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('src/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('src/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Login />
      },
      {
        path: 'login',
        element: <Navigate to="/" replace />
      },
      {
        path: 'dashboard',
        element: <PrivateRoute />,
        children: [
          {
            path: '',
            element: <Overview />
          },
          {
            path: 'overview',
            element: <Overview />
          },
          {
            path: 'category',
            element: <Category />
          },
          {
            path: 'subcategory',
            element: <SubCategory />
          },
          {
            path: 'audio',
            element: <Audio />
          },
          {
            path: 'artists',
            element: <Artists />
          },
          {
            path: 'reviews',
            element: <Reviews />
          },
          {
            path: 'addAudios',
            element: <AddAudio />
          },
          {
            path: 'privacy-policy',
            element: <PrivacyPolicy />
          },
          {
            path: 'term&condition',
            element: <TermAndCondition />
          },
          {
            path: 'about-us',
            element: <AboutUs />
          },
          {
            path: 'send-notification',
            element: <SendNotification />
          }
        ]
      },

      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },
          {
            path: 'settings',
            element: <UserSettings />
          }
        ]
      }
    ]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      },
      {
        path: 'buttons',
        element: <Buttons />
      },
      {
        path: 'modals',
        element: <Modals />
      },
      {
        path: 'accordions',
        element: <Accordions />
      },
      {
        path: 'tabs',
        element: <Tabs />
      },
      {
        path: 'badges',
        element: <Badges />
      },
      {
        path: 'tooltips',
        element: <Tooltips />
      },
      {
        path: 'avatars',
        element: <Avatars />
      },
      {
        path: 'cards',
        element: <Cards />
      },
      {
        path: 'forms',
        element: <Forms />
      }
    ]
  }
];

export default routes;
